import { useCallback } from 'react';
import { useSessionStorage } from 'react-use';
import { type AuthSession, emptySession, sessionStorageKey } from './types';

export function useStoredSession() {
    const [storedAuthSession, writeToSessionStorage] = useSessionStorage<AuthSession>(sessionStorageKey, emptySession);

    const setStoredAuthSession = useCallback(
        (newStoredAuthSession: AuthSession) => {
            if (
                newStoredAuthSession.partnershipId === storedAuthSession.partnershipId &&
                newStoredAuthSession.mandantId === storedAuthSession.mandantId &&
                newStoredAuthSession.clientId === storedAuthSession.clientId
            ) {
                return;
            }

            writeToSessionStorage(newStoredAuthSession);
        },
        [writeToSessionStorage, storedAuthSession],
    );

    const removeStoredAuthSession = useCallback(() => {
        setStoredAuthSession(emptySession);
    }, [setStoredAuthSession]);

    return {
        storedAuthSession,
        setStoredAuthSession,
        removeStoredAuthSession,
    };
}
